/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_niveis': {
    width: 16,
    height: 16,
    viewBox: '0 0 48.698 48.698',
    data: '<path pid="0" d="M24.349 0L.914 13.309l23.436 13.39 23.435-13.39L24.349 0zM8.996 13.319L24.349 4.6l15.354 8.719-15.354 8.772-15.353-8.772z"/><path pid="1" d="M24.349 29.002L8.548 19.974.914 24.309l23.435 13.389 23.435-13.389-7.633-4.335z"/><path pid="2" d="M24.349 40.002L8.548 30.974.914 35.309l23.435 13.389 23.435-13.389-7.633-4.335z"/>'
  }
})
